import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconLogout from '../icons/IconLogout';
import s from './LogoutButton.module.css';
import { logout } from '../../../shared/api/authApi';
import { axiosInstance } from '../../api/axiosInstance';
import { useAppDispatch } from '../../../store/store';
import { toast } from 'react-toastify';
interface LogoutButtonProps {
    onClick?: () => void;
    text?: string;
    showIcon?: boolean;
    className?: string;
    disabled?: boolean;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({
    onClick,
    text = 'Logout',
    showIcon = true,
    className,
    disabled = false,
}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleLogout = async () => {
        if (onClick) {
            onClick();
            return;
        }

        try {
            await axiosInstance.post('/auth/logout');
            localStorage.removeItem('authToken');

            await dispatch(logout());
            dispatch({ type: 'RESET_APP' });
            navigate('/auth');
        } catch (error: any) {
            toast.error(error?.message || 'Failed to logout');
            console.error('Logout request failed:', error);
        }
    };

    return (
        <button
            className={`${s.logout_button} ${className || ''}`}
            onClick={handleLogout}
            disabled={disabled}
        >
            {showIcon && <IconLogout width={21} height={21} color="black" opacity={0.7} />}
        </button>
    );
};

export default LogoutButton;
